<template>


        <v-card  class="overview" elevation=0 >
            <v-card-title class="pa-0">



                <v-img  :src="(business.overviewimage=='null' || business.overviewimage==null || business.overviewimage=='')?bannerImg:business.overviewimage " aspect-ratio="1" class="lighten-2 " max-height="287">
                    <v-row class="fill-height align-center" >
                        <v-col cols="12" md="12" sm="12" class="text-center white--text">
                            <!-- <h2 class="heading white--text" >{{business.businesscode}}</h2> -->
                            <div v-if="business.overviewimagetitle==''">
                                <!-- <h2 class="heading" >{{business.businessName}}</h2>
                                <span class="subtitle-1">{{business.addressLine3}} {{business.addressLine4}}</span>

                                <v-row justify="center">

                                    <v-col cols="12" md="12" sm="12"  align="center" class="text-center">
                                        <v-icon v-for="n in business.starrating" :key="n" color="#FEC83D" >mdi-star</v-icon>

                                    </v-col>

                                </v-row> -->
                            </div>
                            <div v-else>
                                <h2 class="heading" >{{business.overviewimagetitle}}</h2>
                                <span class="subtitle-1 pl-3 pr-3">{{business.overviewimagedescription}} </span>
                            </div>
                        </v-col>

                    </v-row>

                </v-img>


            </v-card-title>

            <v-card-text class="mb-auto pwa-content pa-0">

                <v-tabs
                    :background-color= "business.themecolor!=NULL?business.themecolor:'#FE5800'"
                  color="#FE5800" grow>

                    <v-tab href="#tab-overview" key="1" ><span class="white--text">{{ $t('zz_overview')}}</span></v-tab>
                    <v-tab href="#tab-contacts" key="2"><span class="white--text">{{ $t('zz_contacts')}}</span></v-tab>
                    <v-tab href="#tab-hours" key="3"><span class="white--text">{{$t('zz_hours')}}</span></v-tab>

                    <v-tab-item class="pb-80" key="1" value="tab-overview">
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12" md="12" sm="12">
                                    <h1 class="mb-2" v-if="business.businessName!='null' && business.businessName!=''">{{business.businessName}}</h1>
                                    <h2 class="font-weight-regular subtitle-1">
                                        <span v-if="business.addressLine3!='null' && business.addressLine3!='' && business.addressLine3!=null">{{business.addressLine3}}</span> <span v-if="business.addressLine4!='null' && business.addressLine4!='' && business.addressLine4!=null">{{' '+business.addressLine4}}</span></h2>

                                    <v-row>

                                            <v-col cols="12" md="12" sm="12">
                                                <v-icon v-for="n in business.starrating" :key="n" color="#F39862" dense>mdi-star</v-icon>

                                            </v-col>

                                    </v-row>

                                    <!-- <h3 class="mt-2 mb-2">Description</h3> -->
                                    <!-- <div>{{shortdesc}}</div> -->
                                    <v-row v-if="business.description!='' && business.description!='null' && business.description!=null">
                                        <v-col cols="12" md="12" sm="12" class="pt-0" :class="{shortdesc:!longdesc}"
                                        v-html="userlangcode==''?business.description:business.languagetranslations[userlangcode]" ></v-col>

                                        <v-col v-if="business.description.length>350" cols="12" md="12" sm="12" class="pt-0 pb-0 mt-2" >
                                            <a @click="longdesc=!longdesc" class="btn-read-more"><span v-if="!longdesc">{{$t('zz_read_more')}}</span><span v-if="longdesc">Show Less</span></a>
                                        </v-col>

                                        <!-- <v-col cols="12" md="12" sm="12" class="pt-0" v-if="longdesc" v-html="business.description "></v-col>
                                        <v-col cols="12" md="12" sm="12" class="pt-0 pb-0" v-if="longdesc">
                                            <a @click="longdesc=!longdesc" class="btn-read-more">Show Less</a>
                                        </v-col>     -->
                                     </v-row>

                                    <v-row v-if="business.facilities.length>0">

                                        <v-col cols="12" md="12" sm="12">
                                            <h3 class="mt-2 mb-2">{{$t('zz_facilities')}}</h3>
                                             <v-slide-group multiple >
                                                <v-slide-item
                                                    v-for="(item,index) in business.facilities" :key="index">
                                                <v-btn class="f-btn mr-1 mb-2 pt-1 pb-1" height="auto" small  elevation="0">


                                                    <a v-if="item.link!=''" :href="item.link" target="_blank">
                                                        <v-icon class="mb-1"  @click.stop="dialog = true" @click="setItem(item.facility,item.description)">{{item.icon}}</v-icon>


                                                    </a>


                                                    <v-icon v-else class="mb-1"  @click.stop="dialog = true" @click="setItem(item.facility,item.description)">{{item.icon}}</v-icon>

                                                    <!-- <v-icon class="mb-1" >{{item.icon}}</v-icon> -->


                                                </v-btn>
                                                </v-slide-item>
                                            </v-slide-group>

                                        </v-col>
                                    </v-row>

                                    <v-dialog v-model="dialog"  max-width="800px">
                                        <!-- <template v-slot:activator="{ on }">
                                            <v-btn color="" style="color:#fff;" class="mr-1 purple " v-on="on">Facility</v-btn>
                                        </template> -->

                                        <v-card>
                                            <v-card-title >
                                                <span class="headline">{{facilitiyTitle}}</span>
                                                <v-spacer></v-spacer>
                                                <v-btn text icon color="red darken-1"  @click="dialog = false">
                                                    <v-icon>mdi-close-circle</v-icon>
                                                </v-btn>
                                            </v-card-title>

                                            <v-card-text v-if="facilityDesc!=''">
                                                <v-row>
                                                    <v-col cols="12" md="12" sm="12">
                                                        {{facilityDesc}}
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>

                                            <!-- <v-card-actions v-if="facilityDesc!=''">
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>

                                            </v-card-actions> -->
                                        </v-card>

                                    </v-dialog>



                                    <v-row class="mb-3" v-if="business.bgallery.length>0">

                                        <v-col cols="12" sm="12" md="12">
                                            <h3 class="mt-2 mb-2">{{$t('zz_gallery')}}</h3>
                                        </v-col>
                                        <v-col cols="4" sm="4" md="4" v-for="(item,index) in business.bgallery" :key="index" class="mb-1 pa-0 pr-1">

                                             <v-img :src="item.imageurl" width="150" height="150" class="mr-1 " @click="openslideshow(index)"></v-img>
                                        </v-col>


                                    </v-row>


                                </v-col>
                            </v-row>
                            <v-dialog v-model="dialoggl" max-width="100%">
                                        <v-carousel hide-delimiters>
                                                <v-carousel-item
                                                v-for="(item,i) in items"
                                                :key="i"
                                                :src="item.src"
                                            ></v-carousel-item>
                                        </v-carousel>
                                        <!-- <p class="mb-4 pb-4"></p> -->
                                <v-footer
                                absolute
                                class="font-weight-medium "
                                color="transparent "
                                style="bottom:55px !important">
                                <v-col
                                    class="text-center"
                                    cols="12"
                                >
                                    <v-btn @click="dialoggl=false" fab small color="#fe5800" >
                                            <v-icon class="white--text ">mdi-close</v-icon>
                                    </v-btn>
                                </v-col>
                                </v-footer>
                            </v-dialog>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item class="pb-80" key="2" value="tab-contacts">
                        <v-container fluid>
                            <v-row>
                                <v-col>
                                    <v-card class="mb-5">
                                        <v-card-text class="pt-0 pb-0">
                                            <v-row>
                                                <v-col cols="3" md="3" sm="3">
                                                    <v-avatar>
                                                        <img v-if="business.conimgthumb!=''" :src="business.conimgthumb" />
                                                    </v-avatar>
                                                </v-col>
                                                <v-col cols="9" md="9" sm="9">
                                                    <!-- <div class="title" v-if="business.contactName">{{business.contactName}}</div> -->
                                                    <div class="title" v-if="business.contactFirstName">{{business.contactFirstName+' '+business.contactLastName}}</div>

                                                    <div class="subtitle-1" v-if="business.contactPosition">{{business.contactPosition}}</div>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    <v-card class=" mb-5" v-if="business.phone!='' && business.phone!='null' && business.phone!=null">
                                        <v-card-text class="pt-0 pb-0" style="padding-left:12px;">
                                            <v-row align="center" >
                                                <v-col cols="2" md="2" sm="2" class="" align="center" style="">

                                                  <a :href="'tel:'+business.phone.replace(/\s/g,'').trim()">
                                                    <v-icon size="32" >mdi-phone-in-talk</v-icon>
                                                  </a>

                                                </v-col>
                                                <v-col cols="10" md="10" sm="10" class="pt-0 pb-0">
                                                    <div color="#7697A1" class="body-1">
                                                        <!-- <a :href="'tel:'+business.phone.replace(/\+/g,'').replace(/\s/g,'').trim()">{{business.phone}}</a> -->
                                                        <a :href="'tel:'+business.phone.replace(/\s/g,'').trim()">{{business.phone}}</a>
                                                    </div>

                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>

                                    <v-card class="mb-5" v-if="(business.whatsapp!=null && business.whatsapp!='null' && business.whatsapp!='')">
                                        <v-card-text class="pt-0 pb-0" style="padding-left:12px;">
                                            <v-row align="center">
                                                <v-col cols="2" md="2" sm="2" class="" align="center" style="">
                                                    <a :href="'https://api.whatsapp.com/send?phone='+business.whatsapp.replace(/\s/g,'').trim()+'&text='+business.whatsapmsg">
                                                        <v-icon size="32" >mdi-whatsapp</v-icon>
                                                    </a>

                                                </v-col>
                                                <v-col cols="10" md="10" sm="10" class="pt-0 pb-0">
                                                    <div color="#7697A1" class="body-1">
                                                        <!-- <a :href="'https://api.whatsapp.com/send?phone='+business.whatsapp.replace(/\+/g,'').replace(/\s/g,'').trim()+'&text=hi'">{{business.whatsapp}}</a> -->

                                                        <a :href="'https://api.whatsapp.com/send?phone='+business.whatsapp.replace(/\s/g,'').trim()+'&text='+business.whatsapmsg">{{business.whatsapp}}</a>

                                                    </div>

                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    <a :href="'https://www.google.com/maps/search/?api=1&query='+businessaddress" target="_blank">
                                    <v-card class="mb-5" v-if="(business.addressLine1!=null && business.addressLine1!='null') || (business.addressLine2!=null && business.addressLine2!='null') || (business.addressLine3!=null && business.addressLine3!='null') || (business.addressLine4!=null && business.addressLine4!='null') || (business.addressLine5!=null && business.addressLine5!='null')">
                                        <v-card-text class="pt-0 pb-0" style="padding-left:12px;">
                                            <v-row align="center">
                                                <v-col cols="2" md="2" sm="2" class="fullheight" align="center" style="">

                                                  <v-icon size="32" >mdi-map-marker</v-icon>

                                                </v-col>
                                                <v-col cols="10" md="10" sm="10" class="pt-0 pb-0">
                                                    <div color="#7697A1" class="body-1">
                                                        <span v-if="(business.addressLine1!=null && business.addressLine1!='null') ">

                                                            {{business.addressLine1}}
                                                        </span>
                                                        <span v-if="(business.addressLine2!=null && business.addressLine2!='null')">

                                                            {{business.addressLine2}}
                                                        </span>
                                                        <span v-if="(business.addressLine3!=null && business.addressLine3!='null') ">

                                                            {{business.addressLine3}}
                                                        </span>
                                                        <span v-if="(business.addressLine4!=null && business.addressLine4!='null') ">

                                                            {{business.addressLine4}}
                                                        </span>
                                                        <span v-if="(business.addressLine5!=null && business.addressLine5!='null')">

                                                            {{business.addressLine5}}
                                                        </span>
                                                        <span v-if="business.postcode"> {{business.postcode}}</span>
                                                        <span v-if="business.country"> {{business.country}}</span>
                                                    </div>


                                                </v-col>








                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    </a>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item class="pb-80" key="3" value="tab-hours">
                        <v-container fluid>
                            <v-row>
                               <v-col cols="12" md="12" sm="12">
                                    <h1 class="mb-2">{{$t('zz_hours')}}</h1>
                                    <span v-if="business.openinghoursother!=''">{{business.openinghoursother}}</span>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="12" sm="12">
                                    <v-simple-table>
                                        <template v-slot:default>

                                            <tbody>
                                                <tr>
                                                    <td class="capitalised pl-2 pr-0 " width="85">{{$t('zz_monday')}}</td>

                                                    <!-- <td class="pl-0 pr-0 " width="40"><v-icon>mdi-clock</v-icon></td> -->

                                                    <td class="pl-0 pr-0 " >
                                                        <span v-if="(business.mondayopening!=0 && business.mondayclosing!=0)  && (business.mondayopening!='allwaysopen' && business.mondayclosing!='allwaysopen')">
                                                        {{business.mondayopening}} - {{business.mondayclosing}} </span>

                                                        <span v-else-if="(business.mondayopening=='allwaysopen' && business.mondayclosing=='allwaysopen')">{{$t('zz_always_open')}}</span>


                                                         <span v-else
                                                          :style="[ business.themecolor!=NULL?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                                                          >{{$t('zz_closed')}}</span>

                                                        </td>

                                                    <td class="pl-0 pr-0"  width="30"><span v-if="(business.mondayopening2!=0 && business.mondayclosing2!=0) && (business.mondayopening2!='allwaysopen' && business.mondayclosing2!='allwaysopen') && (business.mondayopening2!=null && business.mondayclosing2!=null) && (business.mondayopening2!='null' && business.mondayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 " >
                                                        <span v-if="(business.mondayopening2!=0 && business.mondayclosing2!=0) && (business.mondayopening2!='allwaysopen' && business.mondayclosing2!='allwaysopen') && (business.mondayopening2!=null && business.mondayclosing2!=null) && (business.mondayopening2!='null' && business.mondayclosing2!='null')">
                                                            {{business.mondayopening2}} - {{business.mondayclosing2}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr style="background:#F6F7F8;">
                                                    <td class="capitalised pl-2 pr-0 ">{{$t('zz_tuesday')}}</td>

                                                    <!-- <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td> -->

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.tuesdayopening!=0 && business.tuesdayclosing!=0) && (business.tuesdayopening!='allwaysopen' && business.tuesdayclosing!='allwaysopen')">{{business.tuesdayopening}} - {{business.tuesdayclosing}} </span>

                                                        <span v-else-if="(business.tuesdayopening=='allwaysopen' && business.tuesdayclosing=='allwaysopen')">{{$t('zz_always_open')}}</span>

                                                        <span v-else
                                                        :style="[ business.themecolor!=NULL?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                                                        style="color:#fe5800">
                                                            {{$t('zz_closed')}}
                                                        </span>
                                                    </td>

                                                    <td class="pl-0 pr-0 " ><span v-if="(business.tuesdayopening2!=0 && business.tuesdayclosing2!=0) && (business.tuesdayopening2!='allwaysopen' && business.tuesdayclosing2!='allwaysopen') && (business.tuesdayopening2!=null && business.tuesdayclosing2!=null) && (business.tuesdayopening2!='null' && business.tuesdayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 " >
                                                        <span v-if="(business.tuesdayopening2!=0 && business.tuesdayclosing2!=0) && (business.tuesdayopening2!='allwaysopen' && business.tuesdayclosing2!='allwaysopen') && (business.tuesdayopening2!=null && business.tuesdayclosing2!=null) && (business.tuesdayopening2!='null' && business.tuesdayclosing2!='null')">
                                                            {{business.tuesdayopening2}} - {{business.tuesdayclosing2}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="capitalised pl-2 pr-0 ">{{$t('zz_wednesday')}}</td>

                                                    <!-- <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td> -->

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.wednesdayopening!=0 && business.wednesdayclosing!=0) && (business.wednesdayopening!='allwaysopen' && business.wednesdayclosing!='allwaysopen')">{{business.wednesdayopening}} - {{business.wednesdayclosing}}
                                                        </span>

                                                        <span v-else-if="(business.wednesdayopening=='allwaysopen' && business.wednesdayclosing=='allwaysopen')">
                                                            {{$t('zz_always_open')}}
                                                        </span>

                                                        <span v-else
                                                        :style="[ business.themecolor!=NULL?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                                                        style="color:#fe5800">{{$t('zz_closed')}}</span>

                                                    </td>

                                                    <td class="pl-0 pr-0 "><span v-if="(business.wednesdayopening2!=0 && business.wednesdayclosing2!=0) && (business.wednesdayopening2!='allwaysopen' && business.wednesdayclosing2!='allwaysopen') && (business.wednesdayopening2!=null && business.wednesdayclosing2!=null) && (business.wednesdayopening2!='null' && business.wednesdayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.wednesdayopening2!=0 && business.wednesdayclosing2!=0) && (business.wednesdayopening2!='allwaysopen' && business.wednesdayclosing2!='allwaysopen') && (business.wednesdayopening2!=null && business.wednesdayclosing2!=null) && (business.wednesdayopening2!='null' && business.wednesdayclosing2!='null')">
                                                            {{business.wednesdayopening2}} - {{business.wednesdayclosing2}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr style="background:#F6F7F8;">
                                                    <td class="capitalised pl-2 pr-0 " >{{$t('zz_thursday')}}</td>

                                                    <!-- <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td> -->

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.thursdayopening!=0 && business.thursdayclosing!=0) && (business.thursdayopening!='allwaysopen' && business.thursdayclosing!='allwaysopen')">{{business.thursdayopening}} - {{business.thursdayclosing}}</span>

                                                        <span v-else-if="(business.thursdayopening=='allwaysopen' && business.thursdayclosing=='allwaysopen')">
                                                            {{$t('zz_always_open')}}
                                                        </span>

                                                        <span v-else
                                                        :style="[ business.themecolor!=NULL?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                                                        style="color:#fe5800">{{$t('zz_closed')}}</span>
                                                    </td>

                                                    <td class="pl-0 pr-0 "><span v-if="(business.thursdayopening2!=0 && business.thursdayclosing2!=0) && (business.thursdayopening2!='allwaysopen' && business.thursdayclosing2!='allwaysopen') && (business.thursdayopening2!=null && business.thursdayclosing2!=null) && (business.thursdayopening2!='null' && business.thursdayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.thursdayopening2!=0 && business.thursdayclosing2!=0) && (business.thursdayopening2!='allwaysopen' && business.thursdayclosing2!='allwaysopen') && (business.thursdayopening2!=null && business.thursdayclosing2!=null) && (business.thursdayopening2!='null' && business.thursdayclosing2!='null')">
                                                            {{business.thursdayopening2}} - {{business.thursdayclosing2}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="capitalised pl-2 pr-0 ">{{$t('zz_friday')}}</td>

                                                    <!-- <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td> -->

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.fridayopening!=0 && business.fridayclosing!=0) && (business.fridayopening!='allwaysopen' && business.fridayclosing!='allwaysopen')">
                                                             {{business.fridayopening}} - {{business.fridayclosing}}
                                                        </span>

                                                         <span v-else-if="(business.fridayopening=='allwaysopen' && business.fridayclosing=='allwaysopen')">{{$t('zz_always_open')}}</span>

                                                         <span v-else
                                                         :style="[ business.themecolor!=NULL?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                                                         style="color:#fe5800">{{$t('zz_closed')}}</span>

                                                    </td>

                                                    <td class="pl-0 pr-0 ">

                                                        <span v-if="(business.fridayopening2!=0 && business.fridayclosing2!=0) && (business.fridayopening2!='allwaysopen' && business.fridayclosing2!='allwaysopen') && (business.fridayopening2!=null && business.fridayclosing2!=null) && (business.fridayopening2!='null' && business.fridayclosing2!='null')">&</span>

                                                    </td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.fridayopening2!=0 && business.fridayclosing2!=0) && (business.fridayopening2!='allwaysopen' && business.fridayclosing2!='allwaysopen') && (business.fridayopening2!=null && business.fridayclosing2!=null) && (business.fridayopening2!='null' && business.fridayclosing2!='null')">
                                                            {{business.fridayopening2}} - {{business.fridayclosing2}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr style="background:#F6F7F8;">
                                                    <td class="capitalised pl-2 pr-0 ">{{$t('zz_saturday')}}</td>

                                                    <!-- <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td> -->

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.saturdayopening!=0 && business.saturdayclosing!=0) && (business.saturdayopening!='allwaysopen' && business.saturdayclosing!='allwaysopen')">
                                                        {{business.saturdayopening}} - {{business.saturdayclosing}} </span>

                                                        <span v-else-if="(business.saturdayopening=='allwaysopen' && business.saturdayclosing=='allwaysopen')">
                                                            {{$t('zz_always_open')}}
                                                        </span>

                                                        <span v-else
                                                        :style="[ business.themecolor!=NULL?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                                                        style="color:#fe5800">{{$t('zz_closed')}}</span>

                                                    </td>

                                                    <td class="pl-0 pr-0 " ><span v-if="(business.saturdayopening2!=0 && business.saturdayclosing2!=0) && (business.saturdayopening2!='allwaysopen' && business.saturdayclosing2!='allwaysopen') && (business.saturdayopening2!=null && business.saturdayclosing2!=null) && (business.saturdayopening2!='null' && business.saturdayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 " >
                                                      <span v-if="(business.saturdayopening2!=0 && business.saturdayclosing2!=0) && (business.saturdayopening2!='allwaysopen' && business.saturdayclosing2!='allwaysopen') && (business.saturdayopening2!=null && business.saturdayclosing2!=null) && (business.saturdayopening2!='null' && business.saturdayclosing2!='null')">  {{business.saturdayopening2}} - {{business.saturdayclosing2}}</span>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="capitalised pl-2 pr-0 " >{{$t('zz_sunday')}}</td>

                                                    <!-- <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td> -->

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.sundayopening!=0 && business.sundayclosing!=0) && (business.sundayopening!='allwaysopen' && business.sundayclosing!='allwaysopen')">
                                                            {{business.sundayopening}} - {{business.sundayclosing}}
                                                        </span>

                                                        <span v-else-if="(business.sundayopening=='allwaysopen' && business.sundayclosing=='allwaysopen')">
                                                            {{$t('zz_always_open')}}
                                                        </span>

                                                        <span v-else
                                                        :style="[ business.themecolor!=NULL?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                                                        style="color:#fe5800">{{$t('zz_closed')}}</span>
                                                    </td>

                                                    <td class="pl-0 pr-0 " ><span v-if="(business.sundayopening2!=0 && business.sundayclosing2!=0) &&  (business.sundayopening2!='allwaysopen' && business.sundayclosing2!='allwaysopen') && (business.sundayopening2!=null && business.sundayclosing2!=null) && (business.sundayopening2!='null' && business.sundayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 " >
                                                        <span v-if="(business.sundayopening2!=0 && business.sundayclosing2!=0) &&  (business.sundayopening2!='allwaysopen' && business.sundayclosing2!='allwaysopen') && (business.sundayopening2!=null && business.sundayclosing2!=null) && (business.sundayopening2!='null' && business.sundayclosing2!='null')">{{business.sundayopening2}} - {{business.sundayclosing2}}</span></td>


                                                </tr>


                                            </tbody>

                                        </template>
                                    </v-simple-table>
                                </v-col>


                            </v-row>
                        </v-container>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>




        </v-card>



</template>
<script >

import Vue from 'vue'
export default {
    props: ['business','tag']  ,

  data: () => ({
    getdirection:'',
    bannerImg:require('@/assets/overview-banner.jpg'),
   // bannerImg:'',
    logoImg:require('@/assets/logo.svg'),
    loading:false,
    isUsed: false,
    longdesc:false,
    search: null,
    valid: true,
    isAgent: false,
    isSameUser:false,
    business_id: 0,
    businesses: [],
    storeBusiness: [],
    tagBusiness: {},
    code:0,
    starrating:0,
    activeBtn: 0,
    shortdesc:'',
    facilitiy:[],
    facilities_id:"",
    facilities:[{'id':'','facility':'','link':'','description':''}],
    bgallery:[],
    dialog: false,
    facilityDesc:'',
    facilitiyTitle:'',
    showbDetails:true,
    tag:'',
    items:[],
    dialoggl:false,
    model:0,
    userlangcode:'',


  }),
  created()
    {

        // this.userlangcode=localStorage.getItem('langcode')||'';
        console.log("business id "+this.business.id);
        this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
        if(!this.userlangcode){
          this.userlangcode="";
        }


    },
  computed:{
      businessaddress:function(){
          var address='';
            address=this.business.businessName;
          if(this.business.addressLine1!=null && this.business.addressLine1!='null' && this.business.addressLine1!='' && this.business.addressLine1!='NULL'){
              address=address+' '+this.business.addressLine1;
          }
          if(this.business.addressLine2!=null && this.business.addressLine2!='null' && this.business.addressLine2!='' && this.business.addressLine2!='NULL'){
              address=address+' '+this.business.addressLine2;
          }
          if(this.business.addressLine3!=null && this.business.addressLine3!='null' && this.business.addressLine3!='' && this.business.addressLine3!='NULL'){
              address=address+' '+this.business.addressLine3;
          }
          if(this.business.addressLine4!=null && this.business.addressLine4!='null' && this.business.addressLine4!='' && this.business.addressLine4!='NULL'){
              address=address+' '+this.business.addressLine4;
          }
          if(this.business.addressLine5!=null && this.business.addressLine5!='null' && this.business.addressLine5!='' && this.business.addressLine5!='NULL'){
              address=address+' '+this.business.addressLine5;
          }
          if(this.business.postcode!=null && this.business.postcode!='null' && this.business.postcode!='' && this.business.postcode!='NULL'){
              address=address+' '+this.business.postcode;
          }
          if(this.business.country!=null && this.business.country!='null' && this.business.country!='' && this.business.country!='NULL'){
              address=address+' '+this.business.country;
          }
          return address;
      }
  },
  watch:{
        business:function(value)
        {
            this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
            if(!this.userlangcode){
                this.userlangcode="";
            }

            return value;
        },
        isloaded:function(value)
        {
            return value;
        },
    },
  methods:
   {
        setItem(fName,fDesc)
        {
            this.facilitiyTitle=fName;
            this.facilityDesc=fDesc;
        },
        getBusiness()
        {
            this.bannerImg=this.businesses.overviewimage;
            if(this.bannerImg==null || this.bannerImg=='null')
            {
                this.bannerImg=require('@/assets/overview-banner.jpg');
            }
        },
        openslideshow(index)
        {
            var evtgal=[];
            this.items=[];
            this.model=index;
            //console.log(this.business.bgallerylarge);
            evtgal=this.business.bgallerylarge;
            for (var i=0;i<evtgal.length;i++){
            this.items.push({'src':evtgal[i].imageurl});
            }
            this.dialoggl=true;
        }

    } ,
}
</script>
<style scope>
.pwa-content{
    margin-top: -60px;
}
.f-btn .v-btn__content
{
    -webkit-box-orient: vertical;

-webkit-box-direction: reverse;

-ms-flex-direction: column-reverse;

flex-direction: column-reverse;
}
.mt-60-n{
    margin-top:-60px;
}
.pb-80{
    padding-bottom: 80px;
}
.v-card__title{
    word-break: normal;
}
.align-cnt
{
    text-align: center;
}
.btn-read-more,.v-application a.btn-read-more{
    padding: 5px;
    background: #ef5000;
    color: #fff !important;
    border-radius: 4px;
    margin-bottom: 1rem;
}
.overview .v-slide-group__prev {
        display: none;
    }
.overview .v-slide-group__next{
        display: none;
    }
.longdesc
{
    height: auto;
}
.shortdesc
{
    height:150px;
    overflow:hidden;
}
.fullheight{
    height:100%;
    width:100%;
    align-items: stretch;
}
.capitalised{
    text-transform: capitalize;
}
</style>
